import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
const collections = [{
  id: 1,
  name: 'Obsidian Vault',
  description: 'Stealth-themed peripherals and dark artifacts.',
  image: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=800&q=80',
  count: '12 Items'
}, {
  id: 2,
  name: 'Meridian Series',
  description: 'High-fidelity figurines from iconic sagas.',
  image: 'https://images.unsplash.com/photo-1560253023-3ec5d502959f?w=800&q=80',
  count: '08 Items'
}, {
  id: 3,
  name: 'Aureate Collection',
  description: 'Gold-plated editions for the ultimate display.',
  image: 'https://images.unsplash.com/photo-1592155931584-901ac15763e3?w=800&q=80',
  count: '05 Items'
}];
export function FeaturedCollections() {
  return <section id="collections" className="py-24 bg-[#0A0A0A]" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16 text-center" data-id="element-12">
          <span className="text-[#C9A962] font-mono text-sm tracking-widest uppercase block mb-4" data-id="element-13">
            Curated Series
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-[#F5F5F0] mb-6" data-id="element-14">
            The Collections
          </h2>
          <div className="w-24 h-1 bg-[#C9A962] mx-auto" data-id="element-15"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-16">
          {collections.map((collection, index) => <motion.div key={collection.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="group relative h-[500px] overflow-hidden rounded-sm cursor-pointer" data-id="element-17">
              <div className="absolute inset-0 bg-[#0A0A0A]/40 group-hover:bg-[#0A0A0A]/20 transition-colors duration-500 z-10" data-id="element-18" />
              <img src={collection.image} alt={collection.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" data-id="element-19" />

              <div className="absolute inset-0 z-20 flex flex-col justify-end p-8 border border-[#F5F5F0]/10 group-hover:border-[#C9A962]/50 transition-colors duration-300" data-id="element-20">
                <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-21">
                  <div className="flex justify-between items-start mb-2" data-id="element-22">
                    <span className="text-[#C9A962] font-mono text-xs tracking-wider uppercase" data-id="element-23">
                      {collection.count}
                    </span>
                    <ArrowUpRight className="text-[#F5F5F0] opacity-0 group-hover:opacity-100 transition-opacity duration-300" size={24} data-id="element-24" />
                  </div>
                  <h3 className="text-2xl font-serif text-[#F5F5F0] mb-2" data-id="element-25">
                    {collection.name}
                  </h3>
                  <p className="text-[#F5F5F0]/70 text-sm max-w-[90%] opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100" data-id="element-26">
                    {collection.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}